export class PageBlockVideo {

    public blockTitle = null;
    public faq = null;
    public id = null;
    public imageUrl = null;
    public removeFromNav = null;
    public slides = null;
    public text = null;
    public type = null;
    public videoData = null;

    constructor(pageBlockVideo) {
        this.blockTitle = pageBlockVideo.blockTitle;
        this.faq = pageBlockVideo.faq;
        this.id = pageBlockVideo.id;
        this.imageUrl = pageBlockVideo.imageUrl;
        this.removeFromNav = pageBlockVideo.removeFromNav;
        this.slides = pageBlockVideo.slides;
        this.text = pageBlockVideo.text;
        this.type = pageBlockVideo.type;
        this.videoData = pageBlockVideo.videoData;
    }

    getMenuElement(url, index) {

        const videoName = this.blockTitle || 'Video' + index;

        return {
            href: url + '#video-' + index,
            name: videoName.replace(/<[^>]*>/g, '')
        };
    }

    getVideoUrl(): string {
        let url = this.videoData.url
        switch (this.videoData.provider) {
          case 0:
            // Other provider
            break;
          case 1:
            // Youtube provider
            url = this.videoData.url + '?autoplay=0&enablejsapi=1&fs=0&modestbranding=1&playsinline=1&rel=0'
            break;
          case 2:
            // Vimeo provider
            url = this.videoData.url + '?autoplay=0&playsinline=1&pip=0&loop=0&autopause=1'
            break;
          case 3:
            // Facebook provider
            break;
          // Other provider
          default:
        }
    
        return url;
      }
}